import { Component, Inject, OnInit } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-showgranthorder',
  templateUrl: './showgranthorder.component.html',
  styleUrl: './showgranthorder.component.scss'
})
export class ShowgranthorderComponent implements OnInit {
  book;
  bookinvoice;
  bookinvoicedata: any[] = [];
  total_total = 0;
  shipping_charges_total = 0;
  total_amount = 0;
  shipping_charges = 0;

  totals;
  toWords;
  amtinwords;
  address;

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<ShowgranthorderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
  }

  ngOnInit(): void {
    this.book = this.data['book'];
    console.log(this.book['rcpt_id']);

    // Reset totals in case this component instance is reused
    this.total_amount = 0;
    this.shipping_charges = 0;

    this.service.getGranthOrderForView(this.book['rcpt_id']).subscribe((data) => {
      console.log(data);
      this.bookinvoice = data;

      if (!this.bookinvoice || !this.bookinvoice.length) {
        this.dialogRef.close();
        alert('Receipt is not Present.');
        return;
      }

      // ✅ Build address only after bookinvoice data is actually available
      this.address = `${this.bookinvoice[0]['address']} ${this.bookinvoice[0]['taluka']}, ${this.bookinvoice[0]['district']}, ${this.bookinvoice[0]['state']}, ${this.bookinvoice[0]['country']},  ${this.bookinvoice[0]['pincode']}`;
      console.log(this.address);
    });

    this.service.getGranthOrderDataForView(this.book['rcpt_id']).subscribe((data) => {
      console.log('Book Data:', data);
      this.bookinvoicedata = data;

      for (
        let index = 0;
        index < Object.keys(this.bookinvoicedata).length;
        index++
      ) {
        this.total_amount =
          this.total_amount + parseInt(this.bookinvoicedata[index]['total']);
        this.shipping_charges =
          this.shipping_charges +
          parseInt(this.bookinvoicedata[index]['shipping_charges']);
      }

      this.totals = this.total_amount + this.shipping_charges;
      this.toWords = new ToWords();
      this.amtinwords = this.toWords.convert(this.totals, {
        currency: true,
      });
    });
  }

  print() {
    window.print();
  }
}